import React, { useState } from "react";
import { PHONE } from "../mock";

const Contact = () => {
  const [form, setForm] = useState({ name: "", phone: "", email: "", message: "" });
  const [sent, setSent] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSent(true);
    setForm({ name: "", phone: "", email: "", message: "" });
    setTimeout(() => setSent(false), 3500);
  };

  return (
    <section id="contact" className="dhs-contact">
      <div className="dhs-container dhs-contact-inner">
        <div className="dhs-contact-left">
          <h2 className="dhs-section-title dhs-contact-title">CONTACT DAN</h2>
          <div className="dhs-section-underline dhs-contact-underline" />
          <p className="dhs-contact-lead">Call Or Text Today For A Free Estimate!</p>
          <a href={`tel:${PHONE}`} className="dhs-contact-phone">{PHONE}</a>
        </div>

        <form className="dhs-contact-form" onSubmit={handleSubmit}>
          <div className="dhs-form-row">
            <input
              className="dhs-input"
              name="name"
              placeholder="Name"
              value={form.name}
              onChange={handleChange}
            />
            <input
              className="dhs-input"
              name="phone"
              placeholder="Phone Number"
              value={form.phone}
              onChange={handleChange}
            />
            <input
              className="dhs-input"
              name="email"
              placeholder="Email"
              value={form.email}
              onChange={handleChange}
            />
          </div>
          <textarea
            className="dhs-textarea"
            name="message"
            placeholder="Message"
            rows={4}
            value={form.message}
            onChange={handleChange}
          />
          <div className="dhs-form-actions">
            {sent && <span className="dhs-form-sent">Thanks! We&apos;ll be in touch.</span>}
            <button type="submit" className="dhs-send-btn">SEND MESSAGE</button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default Contact;
